import { notification } from "antd";
import { NotificationPlacement } from "antd/es/notification/interface";
import React, { useEffect } from "react";

function Notification({ open, close, content }: { open: boolean; close: any; content: string }) {
    useEffect(() => {
        open && openNotification("top");
    });

    const openNotification = (placement: NotificationPlacement) => {
        notification.info({
            message: "알림",
            description: content,
            placement,
        });

        close(false);
    };

    return <></>;
}

export default Notification;
